// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration=staging` replaces `environment.ts` with `environment.staging.ts`.
// `ng build --configuration=production` replaces `environment.ts` with `environment.prod.ts`.
// `ng serve --configuration=local` replaces `environment.ts` with `environment.local.ts`.
// The default `development` configuration uses this file as-is.
// The list of file replacements can be found in the project.json.

export const environment = {
  production: false,
  environmentName: 'development', // Default to dev environment
  firebase: {
    apiKey: "AIzaSyBQmfi-2iGBa1FcwueXeHfQWnoDLwwkxtw",
    authDomain: "zopstores-6715e.firebaseapp.com",
    projectId: "zopstores-6715e",
    storageBucket: "zopstores-6715e.appspot.com",
    messagingSenderId: "539681618321",
    appId: "1:539681618321:web:e305b0f054672f0f644230",
    measurementId: "G-BYR5MJB5TM"
  },
  keycloak: {
    url: 'https://auth.zopup.online', // TODO: Replace with your Keycloak server URL
    realm: 'zopup-dev', // TODO: Replace with your Keycloak realm
    clientId: 'zopup-admin-app', // TODO: Replace with your Keycloak clientId for admin app
  },
  api: {
    baseUrl: 'https://zopup-api-gateway.proudpond-04edd507.centralus.azurecontainerapps.io',
    endpoints: {
      // Admin app API endpoints - explicit domain mapping
      audit: 'https://zopup-audit-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      brands: 'https://zopup-brands-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      companies: 'https://zopup-companies-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      contacts: 'https://zopup-contacts-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      currencies: 'https://zopup-currencies-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      customers: 'https://zopup-customers-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      documents: 'https://zopup-documents-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      finance: 'https://zopup-finance-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      infrastructure: 'https://zopup-infrastructure-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      inventory: 'https://zopup-inventory-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      locations: 'https://zopup-locations-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      productCatalogue: 'https://zopup-product-catalogue-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      sales: 'https://zopup-sales-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      scheduler: 'https://zopup-scheduler-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      settings: 'https://zopup-settings-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      subscriptions: 'https://zopup-subscriptions-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      tasks: 'https://zopup-tasks-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      tax: 'https://zopup-tax-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      users: 'https://zopup-users-api.proudpond-04edd507.centralus.azurecontainerapps.io',
      vendors: 'https://zopup-vendors-api.proudpond-04edd507.centralus.azurecontainerapps.io',
    }
  }
};

// apiKey: 'AIzaSyD4zdchdWya4fbXYQxr1vnlMP-AEXEK_5k',
//       authDomain: 'calibration-aa463.firebaseapp.com',
//       projectId: 'calibration-aa463',
//       storageBucket: 'calibration-aa463.appspot.com',
//       messagingSenderId: '661682529840',
//       appId: '1:661682529840:web:dcd8742442e5296d4eaff5',

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
